const translations = {
  "general": "ogólne",
  "parking": "parking",
  "free WiFi": "darmowe WiFi",
  "air conditioning": "klimatyzacja",
  "adapted for disabled people": "przystosowane dla osób niepełnosprawnych",
  "fireplace": "kominek",
  "heating": "ogrzewanie",
  "bedding": "pościel",
  "possibility of cooking": "możliwość gotowania",
  "grill": "grill",
  "tv": "telewizor",
  "room for meetings conferences": "sala konferencyjna",
  "for non smokers": "dla niepalących",
  "wc": "toaleta",
  "fridge": "lodówka",
  "balcony": "balkon",
  "kitchen": "kuchnia",
  "kitchenette": "aneks kuchenny",
  "dining room": "jadalnia",
  "guests can prepare their own meals": "goście mogą przygotowywać posiłki",
  "microwave": "kuchenka mikrofalowa",
  "dishwasher": "zmywarka",
  "dishes cutlery": "naczynia i sztućce",
  "coffee machine": "ekspres do kawy",
  "kettle": "czajnik",
  "bathroom": "łazienka",
  "bath": "wanna",
  "shower": "prysznic",
  "towels": "ręczniki",
  "iron and ironing board": "żelazko i deska do prasowania",
  "toilet paper": "papier toaletowy",
  "soap": "mydło",
  "wasching machine": "pralka",
  "clothes dryer": "suszarka do ubrań",
  "hair dryer": "suszarka do włosów",
  "for children": "dla dzieci",
  "playground": "plac zabaw",
  "baby_dining_chair": "krzesełko do karmienia",
  "toys": "zabawki",
  "playroom": "pokój zabaw",
  "childrens entertainer": "animator dla dzieci",
  "on the premises": "na terenie obiektu",
  "court": "boisko",
  "bicycles": "rowery",
  "gym fitness": "siłownia / fitness",
  "pool table": "stół bilardowy",
  "spa wellness area": "strefa spa i wellness",
  "jacuzzi": "jacuzzi",
  "sauna": "sauna",
  "solarium": "solarium",
  "swimming pool": "basen",
  "radio": "radio",
  "home cinema": "kino domowe",
  "board games": "gry planszowe",
  "books": "książki",
  "ping pong table": "stół do ping-ponga",
  "table football": "piłkarzyki",
  "darts": "rzutki",
  "tennis courts": "korty tenisowe",
  "bonfire": "ognisko",
  "garden furniture": "meble ogrodowe",
  "garden": "ogród",
  "boat": "łódź",
  "canoes": "kajaki",
  "water bikes": "rowery wodne",
  "skis snowboard": "narty / snowboard",
  "sunbathing eq": "sprzęt do opalania",
  "outdoor": "na zewnątrz",
  "airport": "lotnisko",
  "subway": "metro",
  "shopping center": "centrum handlowe",
  "cinema": "kino",
  "theatre": "teatr",
  "security": "ochrona",
  "safe": "sejf",
  "smoke sensor": "czujnik dymu",
  "carbon monixide sensor": "czujnik czadu",
  "fire extinguisher": "gaśnica",
  "first aid kit": "apteczka",
  "garage": "garaż",
  "remote work": "praca zdalna",
  "desk": "biurko",
  "office chair": "fotel biurowy",
  "monitor": "monitor",
  "work space": "miejsce do pracy",
  "co work space": "przestrzeń coworkingowa",
  "fast internet": "szybki internet",
  "portable router": "przenośny router",
  "ecology": "ekologia",
  "vehicle charger": "ładowarka do pojazdów",
  "photovoltaic panels": "panele fotowoltaiczne",
  "waste sorting": "segregacja odpadów",
  "local food": "lokalna żywność",
  "quiet location": "cicha okolica",
  "clean air": "czyste powietrze"
};

 export default function translateToPolish(word) {
  return translations[word] || "Brak tłumaczenia";
};
